import { SimpleLink } from '@banyan/commons/models/simple-link.model';

export const PRIVACY_NOTICE_LINK =
  'https://www.givaudan.com/legal/global-privacy-notice-condensed';

export const LINKEDIN_LINK =
  'https://www.linkedin.com/company/givaudan';

export const FRAGRANCES_LINKS: SimpleLink[] = [
  {
    name: 'personal-care',
    href: 'personal-care',
  },
  {
    name: 'fine-fragrance',
    href: 'fine-fragrance',
  },
  {
    name: 'home-care',
    href: 'home-care',
  },
  {
    name: 'fabric-care',
    href: 'fabric-care',
  },
  {
    name: 'air-freshener',
    href: 'air-freshener',
  },
  {
    name: 'oral-care',
    href: 'oral-care',
  },
];

export const SUPPORT_LINKS: SimpleLink[] = [
  {
    name: 'contact-us',
    href: 'contact',
  },
  {
    name: 'faq',
    href: 'faq',
  },
];

export const COMPANY_LINKS: SimpleLink[] = [
  {
    name: 'who-we-are',
    href: 'who-we-are',
  },
  {
    name: 'trends-inpiration',
    href: 'trends-inspirations',
  },
  {
    name: 'cookie-policy',
    href: 'cookie-policy',
  },
  {
    name: 'global-privacy-notice',
    href: PRIVACY_NOTICE_LINK,
  },
  {
    name: 'terms-of-use',
    href: 'terms-of-use',
  },
];
